import axios from 'axios';
import { ref } from 'vue';
import config from '@/config';

export type CloudinaryUploadResult = {
  public_id: string;
  secure_url: string;
};

const cloudinaryUploadUrl = `https://api.cloudinary.com/v1_1/${config.cloudinaryCloudName}/auto/upload`;

export const useCloudinaryUpload = () => {
  const isUploading = ref(false);
  const uploadError = ref<Error | null>(null);

  const uploadImage = async (
    file: File,
    uploadPreset: string,
  ): Promise<CloudinaryUploadResult> => {
    const formData = new FormData();

    formData.append('file', file);
    formData.append('upload_preset', uploadPreset);

    const client = axios.create({
      withCredentials: false,
    });

    isUploading.value = true;
    uploadError.value = null;

    try {
      const response = await client.post<CloudinaryUploadResult>(
        cloudinaryUploadUrl,
        formData,
      );

      return response.data;
    } catch (error) {
      uploadError.value =
        error instanceof Error ? error : new Error('Cloudinary upload failed.');

      throw uploadError.value;
    } finally {
      isUploading.value = false;
    }
  };

  return {
    isUploading,
    uploadError,
    uploadImage,
  };
};
